//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { storageRecordSaveApi } from '@/api/administration';
export default {
  name: 'Receive',
  components: {
    selectMember: function selectMember() {
      return import('@/components/form-common/select-member');
    },
    selectDepartment: function selectDepartment() {
      return import('@/components/form-common/select-department');
    }
  },
  props: {
    formData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      drawer: false,
      direction: 'rtl',
      type: '0',
      userList: [],
      // 考勤组成员
      frames: [],
      // 考勤组部门
      tableData: [{
        name: ''
      }, {
        name: ''
      }, {
        name: ''
      }],
      selectedFn: [],
      mark: '',
      ids: [],
      loading: false
    };
  },
  methods: {
    handleClose: function handleClose() {
      this.drawer = false;
      this.resize();
    },
    openBox: function openBox() {
      this.drawer = true;
    },
    resize: function resize() {
      this.userList = []; // 选择成员
      this.frames = [];
      this.mark = '';
      this.tableData = [{
        name: ''
      }, {
        name: ''
      }, {
        name: ''
      }];
    },
    close: function close() {
      this.activeDepartment = null;
      this.openStatus = false;
    },
    getSelectList: function getSelectList(data) {
      this.userList = data;
    },
    // 选择成员完成回调
    changeMastart: function changeMastart(data) {
      this.frames = data;
    },
    cardTag: function cardTag(type, index) {
      this.type == 0 ? this.userList.splice(index, 1) : this.frames.splice(index, 1);
    },
    handleRemove: function handleRemove(index) {
      this.tableData.splice(index, 1);
      this.getSelectChange();
    },
    addRow: function addRow() {
      this.tableData.push({});
    },
    // 提交
    handleConfirm: function handleConfirm() {
      var _this = this;
      if (this.type == 0 && this.userList.length <= 0) {
        return this.$message.error('请选择人员');
      } else if (this.type == 1 && this.frames.length <= 0) {
        return this.$message.error('请选择部门');
      } else {
        var user_type = null;
        var user_id = null;
        var storage = [];
        if (this.type == 0) {
          // 人员
          user_type = 0;
          user_id = this.userList[0].value;
        }
        if (this.type == 1) {
          // 部门
          user_type = 1;
          user_id = this.frames[0].id;
        }
        this.tableData.map(function (value) {
          if (_this.formData.type === 0) {
            // 消耗物资
            storage.push({
              id: value.id,
              num: value.sNumber,
              types: 0
            });
          } else {
            // 固定物资
            storage.push({
              id: value.id,
              num: 1,
              types: 1
            });
          }
        });
        var data = {
          types: 1,
          user_type: user_type,
          user_id: user_id,
          storage: storage,
          mark: this.mark
        };
        this.storageRecord(data);
      }
    },
    getInfo: function getInfo() {
      if (this.tableData.length <= 0) {
        return true;
      } else {
        var i = 0;
        this.tableData.map(function (value) {
          if (!value.sNumber) {
            i++;
          }
        });
        return i > 0;
      }
    },
    handleName: function handleName(e, index) {
      var data = JSON.parse(JSON.stringify(this.formData.selectData[e]));
      data.sNumber = 0;
      this.$set(this.tableData, [index], data);
      this.getSelectChange();
    },
    getSelectChange: function getSelectChange() {
      var _this2 = this;
      if (this.tableData && this.tableData.length > 0) {
        this.ids = [];
        this.tableData.forEach(function (value) {
          _this2.ids.push(value.id);
        });
      }
    },
    storageRecord: function storageRecord(data) {
      var _this3 = this;
      this.loading = true;
      storageRecordSaveApi(data).then(function (res) {
        if (res.status == 200) {
          _this3.handleClose();
          _this3.$emit('isOk');
          _this3.resize();
        }
        _this3.loading = false;
      }).catch(function (error) {
        _this3.loading = false;
      });
    }
  }
};